import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .modal-body {
    display: flex;
    flex-direction: column;
  }

  .data-container {
    display: flex;
    font-size: 1.1rem;
    padding-block: 5px;

    .data-key {
      font-weight: bold;
      width: 30%;
    }

    .data-value {
      width: 70%;
    }
  }
`;
